import React, { useState } from 'react';

export default function LoginPage({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: 'Andreas', password }),
      });
      if (r.ok) {
        onLogin();
      } else {
        const data = await r.json();
        setError(data.error || 'Passwort falsch');
      }
    } catch {
      setError('Server nicht erreichbar');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand-mark" aria-hidden="true">L</div>
        <div className="login-kicker">Dachboden</div>
        <h1 className="login-title">Lagerverwaltung</h1>
        <p className="login-copy">Boxen finden, Inhalte dokumentieren und Lagerplätze im Blick behalten.</p>
        <form onSubmit={handleSubmit} className="login-form" noValidate>
          {/* Verstecktes Username-Feld damit Chrome/Safari Passwort speichern kann */}
          <input
            type="text"
            name="username"
            autoComplete="username"
            value="Andreas"
            readOnly
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, width: 0 }}
            tabIndex={-1}
          />
          <input
            className="login-input"
            type="password"
            name="password"
            placeholder="Passwort"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoFocus
          />
          {error && <div className="login-error">{error}</div>}
          <button className="login-button" type="submit" disabled={loading}>
            {loading ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
